module.exports = __webpack_public_path__ + "img/ershouche.e6594d42.png";